<template>
    <div class="md-banner standard" :style="{ marginBottom }">
        <banner
            ref="banner"
            :class="{
                'mg-container': !fullColumn,
                'mobile-no-margin': mobileNoMargin
            }"
            :style="bannerStyle"
            :type="type"
            :mobileType="mobileType"
            :sizeOption="sizeOption"
            :bgColor="bgColor"
            :mobileBgColor="mobileBgColor"
            :pictureOption="pictureOption"
            :pictureListOption="pictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
        >
            <div
                class="title-container f-col"
                :class="{ full: contentFull }"
                :style="contentStyle"
            >
                <div v-if="mode === 'agent'">
                    <h2
                        v-if="title"
                        class="title"
                        :class="{
                            'top-line': showLine && linePos === 'top',
                            'left-line': showLine && linePos === 'left'
                        }"
                    >
                        <div
                            v-if="showLine"
                            class="line"
                            :style="lineStyle"
                        ></div>
                        <div class="text">{{ agent.fullName }}</div>
                    </h2>
                    <div class="sub-title" v-if="agent.shortIntroduction" v-html="agent.shortIntroduction"></div>
                    <agent-share
                        :socialNetworks="agent.socialNetworks"
                    />
                    <div class="phone">
                        <span>{{ $t('md-banner.phone') }}</span>
                        <a
                            target="_top"
                            :href="'tel:' + agent.phone"
                            rel="noopener noreferrer"
                        >
                            {{ $ft.formatPhone(agent.phone) }}
                        </a>
                    </div>
                </div>
                <template v-else>
                    <div
                        v-if="title"
                        class="title"
                        :class="{
                            'top-line': showLine && linePos === 'top',
                            'left-line': showLine && linePos === 'left'
                        }"
                    >
                        <div
                            v-if="showLine"
                            class="line"
                            :style="lineStyle"
                        ></div>
                        <div class="text" v-html="formatFontSize(title, 40)" style="font-family:var(--mg-title-font)"></div>
                    </div>
                    <div v-if="subTitle" class="sub-title" v-html="formatFontSize(subTitle, 20)" style="font-family:var(--font-normal)"></div>
                </template>
                <div
                    v-if="useType === 'video' && videoOption.hidePlayButton"
                    class="video-button"
                >
                    <div class="play-video" @click.stop="doVideoPlay"></div>
                    <div class="video-loading"></div>
                </div>
            </div>
        </banner>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-banner.standard {
    .banner {
        .banner-video .play-video {
            z-index: 3;
        }
        .swiper-pagination-bullet {
            background-color: #ffffff;
            opacity: 0.5;
            @include media-1080 {
                width: 6px;
                height: 6px;
            }
            @include media-600 {
                width: 4px;
                height: 4px;
            }
        }
        .swiper-pagination-bullet-active {
            opacity: 1;
        }
    }
    .title-container {
        position: relative;
        z-index: 2;
        text-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);

        .phone {
            float: left;
            line-height: 20px;
            height: 20px;
            margin-top: 21px;
            border-left: 1px solid #ddd;
            padding-left: 10px;
            margin-left: 10px;
        }
        .title {
            &.top-line {
                position: relative;
                margin-top: 30px;
                .line {
                    margin-bottom: 18px;
                    width: 51px;
                    height: 4px;
                    box-shadow: 0 1px 1px 0 rgba(8, 17, 38, 0.5);
                    @include color-theme('background-color');
                }
            }
            &.left-line {
                display: flex;
                .line {
                    width: 4px;
                    height: auto;
                    @include color-theme('background-color');
                    margin-right: 20px;
                    flex: none;
                }
                .text {
                    flex: 1;
                }
            }
            .text {
                font-size: 40px;
                font-family: var(--mg-title-font);
                line-height: 1.1;
                text-shadow: 0 1px 1px rgba(8, 17, 38, 0.5);
                @include webkitBox(none);
                // @include color-theme();
                p {
                    line-height: inherit;
                    overflow: hidden;
                }
            }
        }
        .sub-title {
            margin-top: 20px;
            font-size: 20px;
            line-height: 1.2;
            text-shadow: 0 1px 1px rgba(8, 17, 38, 0.5);
            p {
                line-height: inherit;
                overflow: hidden;
            }
            h3 {
                line-height: 1.5;
            }
        }
        .video-button {
            margin-top: 30px;
            display: flex;
            justify-content: center;
        }
        .play-video {
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site3/images/play.png)
                no-repeat;
            background-size: cover;
            cursor: pointer;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
        .video-loading {
            display: none;
            width: 80px;
            height: 80px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif)
                no-repeat;
            background-size: cover;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
        @include media-1080 {
            .title .text {
                font-size: 35px;
            }
        }
        @include media-800 {
            .title .text {
                font-size: 30px;
            }
        }
        @include media-600 {
            .title {
                &.top-line {
                    margin-top: 0px;
                    .line {
                        width: 40px;
                        height: 3px;
                        margin-bottom: 15px;
                    }
                }
                .text {
                    font-size: 24px;
                }
            }
            .sub-title {
                font-size: 16px;
                line-height: 1.5;
            }
        }
    }
    .banner-video.autoplay + .title-container,
    .banner-video.is-play + .title-container {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .title-container {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
        display: none;
    }
    .banner-video {
        .play-video,
        .video-loading {
            display: none;
        }
    }
}
</style>
